import api from "@/lib/api";

const fallbackCopy = (text) => {
  const ta = document.createElement("textarea");
  ta.value = text; ta.style.position = "fixed"; ta.style.opacity = "0";
  document.body.appendChild(ta); ta.select();
  const ok = document.execCommand("copy");
  document.body.removeChild(ta);
  return ok;
};

// ClipboardItem with a promise keeps the user gesture (Safari) across the API call.
export const copyFromApi = async (fetchUrl) => {
  let url = "";
  const run = async () => { url = await fetchUrl(); return url; };
  if (window.ClipboardItem && navigator.clipboard?.write) {
    const p = run();
    try {
      await navigator.clipboard.write([new window.ClipboardItem({ "text/plain": p.then((u) => new Blob([u], { type: "text/plain" })) })]);
      return url;
    } catch (e) {
      await p.catch((err) => { throw err; });
      if (!fallbackCopy(url)) throw e;
      return url;
    }
  }
  await run();
  try { await navigator.clipboard.writeText(url); } catch { if (!fallbackCopy(url)) throw new Error("copy"); }
  return url;
};

export const copySignLink = (quote0, prepare) => copyFromApi(async () => {
  const quote = prepare ? await prepare(quote0) : quote0;
  if (!quote) throw new Error("cancelled");
  const { data } = await api.post(`/quotes/${quote.id}/sign-link-url`);
  return data.sign_url;
});
